<template>
<transition name="slide-fade">
    <div class="dialog-view" v-show="visible">        
        <div class="record-modal u-window">           
            <div class="dialog-content">              
                <div class="u-btn close" @click="destroyElement"></div>
                <div class="dialog-wrapper">
                    <div class="dialog-title t-record"></div>

                    <table class="t-head">
                        <thead>
                            <tr>
                                <td style="width: 116px;">序号</td>
                                <td style="width: 140px;">昵称</td>
                                <td>被招募时间</td>
                            </tr>
                        </thead>
                    </table>
                    <div class="records">
                        <div class="record-view">
                            <vuescroll>
                                <div class="data-table">
                                    <table>
                                        <tbody>                                          
                                            <tr v-for="(f,index) in friend_list" :key="index">
                                                <td style="width: 110px;">{{ index + 1 }}</td>
                                                <td style="width: 150px;">{{ f.nickName }}</td>
                                                <td>{{ f.bindTime }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </vuescroll>
                        </div>
                    </div>
                </div>
            </div>
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>    
</template>

<script>
export default {
    name : 'evt_rule_modal',
    data : function () {
        return {
            visible : false,
            friend_list : [],
            total : 0,
            total_share : 0,
            total_score : 0,
            mode : 2,        
        }
    },   
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    created(){
        document.body.style.overflow = 'hidden';
    },     
    mounted (){
        this.render();
    },
    methods: {
        destroyElement () {
            document.body.style.overflow = ''; // 出现滚动条
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },
        render(){
            this.$axios.get(ajax_url_map.friend_list,{
                params : {
                    mode : this.mode
                }
            })
            .then(
                res => {
                    this.friend_list = res.data.list;
                },
                rej => {
                    this.$toast('请稍后再试')
                }
            )
        },
    }    
}
</script>

<style scoped>

    .record-modal{
        width: 629px;
        height: 509px;
        color: #f9e1b0;
        font-size: 20px;
        background-image: url(~@/assets/images/modal/bg-record-friend.png);
    }


    .t-record{
        width: 516px;
        height: 55px;
        margin: 0 auto 20px;
        background-image: url(~@/assets/images/modal/title-record-friend.png);
    }

    .rule-modal .dialog-wrapper{
        /* padding: 20px 0 0; */
    }

    .records{
        width: 500px;
        height: 288px;
        margin-left: 64px;
        margin-bottom: 15px;
        box-sizing: border-box;
    }

    .record-view{
        width: 532px;
        height: 328px;
        box-sizing: border-box;
    }

    table{
        width: 500px;
        box-sizing: border-box;
    }

    .t-head{
        margin-left: 64px;
        margin-bottom: 5px;
        padding: 5px 0;
    }

    thead tr{
        height: 60px;
        color: #49392e;
        text-align: center;
        background-color: #f1ead9;
    }

    .data-table{
        color: #49392e;
    }

    .data-table table{
        width: 500px;
    }

    .data-table tr{
        text-align: center;
        line-height: 55px;       
    }

    .data-table td{
        border-bottom: 1px solid #f1ead9;
    }

    .notice{
        text-align: center;
        margin-bottom: 30px;
    }
    
</style>


// WEBPACK FOOTER //
// src/components/FriendList/Modal.vue